// src/components/BuscadorInput.js
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Input } from "semantic-ui-react";

const BuscadorInput = ({ items, onSelectItem, limpiaFormCte, confirmar, rut = "" }) => {
  const [queryText, setQueryText] = useState(rut);
  const [filteredItems, setFilteredItems] = useState([]);

  useEffect(() => {
    setQueryText(rut);
  }, [rut]);

  const handleInputChange = (event) => {
    const value = event.target.value;
    setQueryText(value);

    if (value.length > 0) {
      const filtered = items.filter(
        (item) =>
          (item.rut || "").toLowerCase().includes(value.toLowerCase()) ||
          (item.nombre || "").toLowerCase().includes(value.toLowerCase())
      );
      setFilteredItems(filtered);
    } else {
      setFilteredItems([]);
      limpiaFormCte?.();
    }
  };

  const handleSelectItem = (item) => {
    // Si viene string (rut escrito) o viene objeto (cliente)
    const isObject = item !== null && typeof item === "object";

    if (isObject) {
      setQueryText(item.rut);
      setFilteredItems([]);
      onSelectItem(item);
    } else {
      // string ingresado
      setFilteredItems([]);
      onSelectItem(item);
    }
  };

  const detectarKey = (e) => {
    if ((e.key === "Enter" || e.key === "Tab") && filteredItems.length === 0) {
      handleSelectItem(e.target.value);
    } else if ((e.key === "Enter" || e.key === "Tab") && filteredItems.length === 1) {
      handleSelectItem(filteredItems[0]);
    }
  };

  return (
    <SearchWrap>
      <Input
        fluid
        style={{ outlineColor: "#F0A70A" }}
        type="text"
        value={queryText}
        onChange={handleInputChange}
        placeholder="Ingrese Rut o Nombre"
        onKeyDown={detectarKey}
        disabled={confirmar}
        icon="address card"
        iconPosition="left"
        onBlur={() => {
          // pequeño delay para permitir click en un item antes de cerrar
          setTimeout(() => setFilteredItems([]), 120);
        }}
        onFocus={() => {
          // si ya hay texto, vuelve a mostrar resultados
          if (queryText?.length > 0) {
            const filtered = items.filter(
              (item) =>
                (item.rut || "").toLowerCase().includes(queryText.toLowerCase()) ||
                (item.nombre || "").toLowerCase().includes(queryText.toLowerCase())
            );
            setFilteredItems(filtered);
          }
        }}
      />

      {filteredItems.length > 0 && (
        <Lista>
          {filteredItems.map((item) => (
            <Li
              key={item.id || item.rut}
              onMouseDown={(e) => e.preventDefault()} // evita blur antes del click
              onClick={() => handleSelectItem(item)}
            >
              {item.rut} {item.nombre}
            </Li>
          ))}
        </Lista>
      )}
    </SearchWrap>
  );
};

export default BuscadorInput;

const SearchWrap = styled.div`
  position: relative;
  width: 100%;
`;

const Lista = styled.ul`
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  z-index: 9999;

  border-radius: 0.625rem;
  background-color: #fff;
  list-style: none;
  padding: 0;
  margin: 0;
  border: 1px solid #ccc;

  max-height: 150px;
  overflow-y: auto;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
`;

const Li = styled.li`
  text-align: left;
  padding: 8px 10px;
  cursor: pointer;

  &:hover {
    background-color: #8cf7f7;
  }
`;
